import { FC } from 'react';
import {
  ResponsiveContainer,
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from 'recharts';
import dayjs from 'dayjs';
import { IReturnConfidenceMetric } from '../../../../models/injury';
import { ChartEmptyState } from './_shared/ChartEmptyState';
import {
  chartAxisTick,
  chartGridProps,
  chartLegendStyle,
  chartTooltipContentStyle,
  chartTooltipItemStyle,
  chartTooltipLabelStyle,
} from '../../../../shared/charts/chartTheme';

interface Props {
  data: IReturnConfidenceMetric | null;
  period?: string;
  height?: number;
}

export const ReturnConfidenceChart: FC<Props> = ({ data, height }) => {
  if (!data || !data.series || data.series.length === 0) {
    return <ChartEmptyState />;
  }

  return (
    <ResponsiveContainer width="100%" height={height ?? 220}>
      <LineChart data={data.series} margin={{ top: 4, right: 16, left: 0, bottom: 0 }}>
        <CartesianGrid {...chartGridProps} />
        <XAxis dataKey="date" tickFormatter={(v) => dayjs(v).format('DD/MM')} tick={chartAxisTick} />
        <YAxis domain={[0, 10]} tick={chartAxisTick} />
        <Tooltip
          contentStyle={chartTooltipContentStyle}
          labelStyle={chartTooltipLabelStyle}
          itemStyle={chartTooltipItemStyle}
          formatter={(value, name) => [value, name === 'confidence' ? 'Fiducia' : 'Paura']}
          labelFormatter={(label) => dayjs(label).format('DD/MM/YYYY')}
        />
        <Legend formatter={(value) => (value === 'confidence' ? 'Fiducia' : 'Paura')} wrapperStyle={chartLegendStyle} />
        <Line
          type="monotone"
          dataKey="confidence"
          stroke="var(--ri-good)"
          strokeWidth={2}
          dot={{ r: 3, fill: 'var(--ri-good)' }}
        />
        <Line
          type="monotone"
          dataKey="fear"
          stroke="var(--ri-critical)"
          strokeWidth={2}
          strokeDasharray="4 3"
          dot={{ r: 3, fill: 'var(--ri-critical)' }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};
